import { useQuery, useQueryClient } from 'react-query';
import api from 'services';
import type { ApiError } from 'services/api.errors';
import { checkCondition } from 'services/api.errors';
import type { EmployerResponse, ID } from 'services/requests';
import { useQueryParams } from 'hooks/routes';
import { QueryKeys } from 'constants/queryKeys';
import { Parameters } from 'constants/queryParameters';
import type { AxiosError } from 'axios';

export const useGetEmployer = (employerId?: number) => {
  const id = employerId ?? useQueryParams(Parameters.employerId);
  const queryKey = [QueryKeys.employer, id];

  return useQuery<EmployerResponse, AxiosError<ApiError, string>>(
    queryKey,
    queryFn(id?.toString(), queryKey),
    {
      enabled: Boolean(id),
      retry: 1,
    },
  );
};

export const useGetEmployerPrefetch = () => {
  const queryClient = useQueryClient();

  return async (id: ID) => {
    const queryKey = [QueryKeys.employer, id];

    await queryClient.prefetchQuery(queryKey, queryFn(id, queryKey), {
      staleTime: 1000,
    });
  };
};

function queryFn(id: ID | undefined, queryKey?: string | unknown[]) {
  return async () => {
    checkCondition(id, queryKey);
    const { data } = await api.getEmployer(id);
    return data;
  };
}
